import { Injectable, signal } from '@angular/core';
import { Notification } from '../models/notification';


@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  notifications = signal<Notification[]>([]);

  show(notification: Omit<Notification, 'id'>) {
    const id = crypto.randomUUID();
    const newNotification: Notification = {
      ...notification,
      id,
      duration: notification.duration ?? 5000,
    };

    this.notifications.update((notifications) => [...notifications, newNotification]);

    // Auto remove after duration
    if (newNotification.duration && newNotification.duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, newNotification.duration);
    }

    return id;
  }

  success(title: string, message?: string, duration?: number) {
    return this.show({ type: 'success', title, message, duration });
  }

  error(title: string, message?: string, duration?: number) {
    return this.show({ type: 'error', title, message, duration });
  }

  warning(title: string, message?: string, duration?: number) {
    return this.show({ type: 'warning', title, message, duration });
  }

  info(title: string, message?: string, duration?: number) {
    return this.show({ type: 'info', title, message, duration });
  }

  remove(id: string) {
    this.notifications.update((notifications) =>
      notifications.filter((notification) => notification.id !== id)
    );
  }

  clear() {
    this.notifications.set([]);
  }
}
